import {
  taxRelationshipEnumSchema,
  TaxRelationshipEnumType,
} from "@libs/api/patients";
import { HouseholdMemberRelationshipsWithMemberType } from "@/domain/householdMemberRelationship";

type TaxRelationshipUpdateOperationType = {
  relationshipId: string;
  taxRelationship: TaxRelationshipEnumType | null;
};

export const filterDependentRelationships = (
  relationships: HouseholdMemberRelationshipsWithMemberType | undefined,
): HouseholdMemberRelationshipsWithMemberType => {
  return (relationships ?? []).filter(
    rel => rel.taxRelationship === taxRelationshipEnumSchema.enum.SUPPORT_OF,
  );
};

export const filterDependentOfRelationships = (
  relationships: HouseholdMemberRelationshipsWithMemberType | undefined,
): HouseholdMemberRelationshipsWithMemberType => {
  return (relationships ?? []).filter(
    rel =>
      rel.taxRelationship === taxRelationshipEnumSchema.enum.DEPENDENT_OF ||
      rel.taxRelationship ===
        taxRelationshipEnumSchema.enum.DEPENDENT_OF_SPOUSE ||
      rel.taxRelationship ===
        taxRelationshipEnumSchema.enum.DEPENDENT_OF_SUPPORTER,
  );
};

export const buildTaxRelationshipUpdateOperations = ({
  existingDependentIds,
  existingDependentOfIds,
  newDependentIds,
  newDependentOfIds,
}: {
  existingDependentIds: string[];
  existingDependentOfIds: string[];
  newDependentIds: string[];
  newDependentOfIds: string[];
}) => {
  const existingDependentIdSet = new Set(existingDependentIds);
  const existingDependentOfIdSet = new Set(existingDependentOfIds);
  const newDependentIdSet = new Set(newDependentIds);
  const newDependentOfIdSet = new Set(newDependentOfIds);

  const toAddDependent = newDependentIds.filter(
    id => !existingDependentIdSet.has(id),
  );
  const toAddDependentOf = newDependentOfIds.filter(
    id => !existingDependentOfIdSet.has(id),
  );

  const toRemoveDependent = existingDependentIds.filter(
    id => !newDependentIdSet.has(id),
  );
  const toRemoveDependentOf = existingDependentOfIds.filter(
    id => !newDependentOfIdSet.has(id),
  );

  const toRemove = [...toRemoveDependent, ...toRemoveDependentOf];

  const operations: TaxRelationshipUpdateOperationType[] = [];

  toAddDependent.forEach(relationshipId => {
    operations.push({
      relationshipId,
      taxRelationship: taxRelationshipEnumSchema.enum.SUPPORT_OF,
    });
  });

  toAddDependentOf.forEach(relationshipId => {
    operations.push({
      relationshipId,
      taxRelationship: taxRelationshipEnumSchema.enum.DEPENDENT_OF,
    });
  });

  toRemove.forEach(relationshipId => {
    operations.push({
      relationshipId,
      taxRelationship: null,
    });
  });

  return operations;
};
